import React, { Suspense, useState, lazy, useEffect } from 'react';
import ReusableScaffold from '../reusable/ReusableScaffold/ReusableScaffold.js';
import { messageManager } from '../System/messageManager/messageManager.js';
import {
  BODY_SLOT,
  getPBBStrategistHeaderButtons,
} from './pbbStrategistHelpers.js';
import CustomChatbot from './PBBStrategistComponents/Chatbot/Chatbot.js';

const SavingsDialog = lazy(
  () => import('./PBBStrategistComponents/SavingsDialog.js'),
);
const ProgramDossierDialog = lazy(
  () => import('./PBBStrategistComponents/ProgramDossierDialog.js'),
);
const FindQuickWinsDialog = lazy(
  () => import('./PBBStrategistComponents/FindQuickWinsDialog.js'),
);
const ImagineWithAIDialog = lazy(
  () => import('./PBBStrategistComponents/ImagineWithAIDialog.js'),
);
import useDepartmentsAndDivisions from '../../customHooks/departmentAndDivisionHook.js';
import { useUser } from '../../contexts/userContext.js';
import { useNameConventions } from '../../contexts/nameConventionsContext.js';
import { useChatActions } from './ChatActionsContext.js';
import ValidationWrapper from '../reusable/Validations/ValidationWrapper.js';
import './PBBStrategist.scss';

const PBBStrategist = () => {
  const {
    onConversationReset,
    waitingResponse,
    onSubmitSavings,
    onSubmitProgramDossier,
    onSubmitQuickWins,
    onSubmitImagineWithAI,
  } = useChatActions();
  const [openDossierDialog, setOpenDossierDialog] = useState(false);
  const [openSavings, setOpenSavings] = useState(false);
  const [openQuickWins, setOpenQuickWins] = useState(false);
  const [openImagineWithAI, setOpenImagineWithAI] = useState(false);
  const { user } = useUser();
  const { nameConventions } = useNameConventions();
  const { filteredDepartmentsFromAccUpload } = useDepartmentsAndDivisions();

  useEffect(() => {
    onConversationReset();
  }, [user?.activeOrganization]);

  const toggleDossierDialog = () => setOpenDossierDialog((prev) => !prev);
  const toggleSavings = () => setOpenSavings((prev) => !prev);
  const toggleQuickWinsDialog = () => setOpenQuickWins((prev) => !prev);
  const toggleImagineWithAI = () => setOpenImagineWithAI((prev) => !prev);
  return (
    <ValidationWrapper validatePrograms>
      <ReusableScaffold
        title={messageManager(nameConventions).PBB_STRATEGIST.TITLE}
        headerButtons={getPBBStrategistHeaderButtons(
          toggleSavings,
          toggleDossierDialog,
          toggleQuickWinsDialog,
          toggleImagineWithAI,
          waitingResponse,
        )}
      >
        <div slot={BODY_SLOT} className="standardMargin">
          <div className="pbb-analyst-container user">
            <CustomChatbot />
            {openSavings && (
              <Suspense>
                <SavingsDialog
                  onClose={toggleSavings}
                  onSubmit={onSubmitSavings}
                  open={openSavings}
                  departments={filteredDepartmentsFromAccUpload}
                />
              </Suspense>
            )}
            {openDossierDialog && (
              <Suspense>
                <ProgramDossierDialog
                  onClose={toggleDossierDialog}
                  onSubmit={onSubmitProgramDossier}
                  open={openDossierDialog}
                  departments={filteredDepartmentsFromAccUpload}
                />
              </Suspense>
            )}
            {openQuickWins && (
              <Suspense>
                <FindQuickWinsDialog
                  onClose={toggleQuickWinsDialog}
                  onSubmit={onSubmitQuickWins}
                  open={openQuickWins}
                  departments={filteredDepartmentsFromAccUpload}
                />
              </Suspense>
            )}
            {openImagineWithAI && (
              <Suspense>
                <ImagineWithAIDialog
                  onClose={toggleImagineWithAI}
                  onSubmit={onSubmitImagineWithAI}
                  open={openImagineWithAI}
                  departments={filteredDepartmentsFromAccUpload}
                />
              </Suspense>
            )}
          </div>
        </div>
      </ReusableScaffold>
    </ValidationWrapper>
  );
};

export default PBBStrategist;
